var render = function render(){var _vm=this,_c=_vm._self._c;return _c('html',[_vm._m(0),_c('body',[_c('center',[_c('h1',[_vm._v("404 Not Found")])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('head',[_c('title',[_vm._v("404 Not Found")])])
}]

export { render, staticRenderFns }